import { Input, InputNumber, Modal, Switch } from 'antd';
import i18next from 'i18next';
import React, { useState } from 'react';
import { DTFSettings } from './settings';

interface IProps {
	open: boolean;
	settings: DTFSettings;
	onSave: (s: DTFSettings) => void;
	onCancel: () => void;
}

const SettingsModal: React.FC<IProps> = ({ open, settings, onSave, onCancel }) => {
	const [draft, setDraft] = useState<DTFSettings>(settings);
	React.useEffect(() => {
		if (open) setDraft(settings);
	}, [open, settings]);
	const num = (key: keyof DTFSettings, label: string, step = 1, min = 0, max?: number) => (
		<label className="dtf-settings-row" key={key}>
			<span>{label}</span>
			<InputNumber
				min={min}
				max={max}
				step={step}
				value={draft[key] as number}
				onChange={v => setDraft({ ...draft, [key]: Number(v) || 0 })}
			/>
		</label>
	);
	return (
		<Modal centered className="dtf-settings-modal"
			open={open}
			title={i18next.t('dtf.reglages')}
			okText={i18next.t('dtf.enregistrer')}
			cancelText={i18next.t('dtf.annuler')}
			onOk={() => onSave(draft)}
			onCancel={onCancel}
			destroyOnClose
		>
			<div className="dtf-settings">
				<label className="dtf-settings-row">
					<span>{i18next.t('dtf.reglages-tenant')}</span>
					<Input value={draft.tenantId} onChange={e => setDraft({ ...draft, tenantId: e.target.value })} style={{ width: 140 }} />
				</label>
				{num('laizeCm', i18next.t('dtf.reglages-laize'), 1, 10)}
				{num('minPlancheCm', i18next.t('dtf.reglages-min-planche'), 1, 10)}
				{num('maxPlancheCm', i18next.t('dtf.reglages-max-planche'), 1, 10)}
				{num('prixCmLineaire', i18next.t('dtf.reglages-prix-cm'), 0.01, 0)}
				{num('minCommande', i18next.t('dtf.reglages-min-commande'), 0.5, 0)}
				{num('margeMm', i18next.t('dtf.reglages-marge'), 1, 5, 15)}
				<label className="dtf-settings-row">
					<span>{i18next.t('dtf.reglages-devise')}</span>
					<Input value={draft.devise} onChange={e => setDraft({ ...draft, devise: e.target.value })} style={{ width: 80 }} />
				</label>
				{num('tvaPct', i18next.t('dtf.reglages-tva'), 0.1, 0)}
				{num('maxFichierMb', i18next.t('dtf.reglages-max-fichier'), 5, 1)}
				<label className="dtf-settings-row">
					<span>{i18next.t('dtf.reglages-ttc')}</span>
					<Switch checked={draft.prixTtc} onChange={v => setDraft({ ...draft, prixTtc: v })} />
				</label>
			</div>
		</Modal>
	);
};

export default SettingsModal;
